/**
 * The `gcloud compute ssh` line on the host card. Most operators paste it as-is;
 * a few hop through another local account to get IAP access, so their prefix is
 * baked in here rather than retyped every time.
 */
import type { HostInstance } from '@finvari/deployer';

/**
 * Paul hops through the `fvprod` user (and that user's Cloud SDK) because that
 * is how IAP SSH is granted on his machine. Add another operator here if they
 * have the same kind of hop, not a different command.
 */
const SSH_COMMAND_PREFIX_BY_EMAIL: Record<string, string> = {
    'paul.mclachlan@finvari.com': 'sudo -iu fvprod /Users/fvprod/google-cloud-sdk/bin/',
};

export function formatSshCommand(vm: Pick<HostInstance, 'instance' | 'zone' | 'project'>, operatorEmail: string): string {
    const prefix = SSH_COMMAND_PREFIX_BY_EMAIL[operatorEmail.toLowerCase()] ?? '';
    return (
        prefix +
        `gcloud compute ssh ${vm.instance} --tunnel-through-iap --zone ${vm.zone} --project ${vm.project}`
    );
}
